function getCommonChunk(name) {
  switch (name) {
    case 'sizeguide-v2':
      return import(/* webpackChunkName: "static/chunk/sizeguide" */ './sizeguide/SizeGuideApp');
      break;
    default:
      return '';
  }
}

module.exports = {
  getCommonChunk,
  getMobileChunk(name) {
    let chunk = getCommonChunk(name);
    if (chunk) {
      return chunk;
    } else {
      switch (name) {
        case 'promoguidelinepage':
          return import(
            /* webpackChunkName: "static/chunk/promoguidelinepage.mobile" */ './components/mobile/eosspromo/PromoGuidelines'
          );
          break;
        case 'capsulepage':
          return import(
            /* webpackChunkName: "static/chunk/capsulepage.mobile" */ './components/mobile/capsule/Capsule'
          );
          break;
        case 'offerspage':
          return import(
            /* webpackChunkName: "static/chunk/offerspage.mobile" */ './offers/components/mobile'
          );
          break;
        case 'storepickup':
          return import(
            /* webpackChunkName: "static/chunk/pickup.mobile" */ './components/common/pickup/mobile'
          );
          break;
        case 'searchpage':
          return import(
            /* webpackChunkName: "static/chunk/searchpage.mobile" */ './components/mobile/search/Search'
          );
          break;
        case 'collectionpage':
          return import(
            /* webpackChunkName: "static/chunk/collectionpage.mobile" */ './components/mobile/capsule/CpPage'
          );
          break;
        case 'landingpage':
          return import(
            /* webpackChunkName: "static/chunk/landingpage.mobile" */ './components/mobile/banner/BannerComponent'
          );
          break;
        case 'categorypage':
          return import(
            /* webpackChunkName: "static/chunk/categorypage.mobile" */ './components/mobile/category/Category'
          );
          break;
        case 'homepage':
          return import(/* webpackChunkName: "static/chunk/homepage.mobile" */ './HomePageChunk');
          break;
        case 'productpage':
          return import(
            /* webpackChunkName: "static/chunk/productpage.mobile" */ './components/mobile/product/ProductPage'
          );
          break;
        case 'cart':
          // return import(/* webpackChunkName: "static/chunk/cart.mobile" */"./cart/components/mobile/cart");
          return import(
            /* webpackChunkName: "static/chunk/cart.mobile" */ './refresh/pages/CartPage'
          );
          break;
        case 'brands':
          return import(
            /* webpackChunkName: "static/chunk/brands.mobile" */ './refresh/pages/Brands'
          );
          break;
        case 'jioengage':
          return import(
            /* webpackChunkName: "static/chunk/jioengage.mobile" */ './refresh/pages/JioEngage'
          );
          break;
        case 'my-account':
          return import(
            /* webpackChunkName: "static/chunk/myaccount.mobile" */ './myaccount/components/mobile/accountLayout'
          );
          break;
        case 'wishlist':
          return import(
            /* webpackChunkName: "static/chunk/wishlist.mobile" */ './wishlist/components/mobile/Wishlist'
          );
          break;
        case 'shipping':
          return import(
            /* webpackChunkName: "static/chunk/shipping.mobile" */ './shipping/components/mobile/Shipping'
          );
          break;
        case 'addresses': {
          return import(
            /* webpackChunkName: "static/chunk/shipping.mobile" */ './manage-addresses/components/mobile/manage-addresses'
          );
        }
        case 'checkout':
          return import(
            /* webpackChunkName: "static/chunk/checkout.mobile" */ './checkout/components/mobile/Checkout'
          );
          break;
        case 'retry':
          return import(
            /* webpackChunkName: "static/chunk/checkout.mobile" */ './checkout/components/mobile/RetryPayment'
          );
          break;
        case 'selfcare':
          return import(
            /* webpackChunkName: "static/chunk/selfcare.mobile" */ './selfcare/components/mobile/Selfcare'
          );
          break;
        case 'itemdetails':
          return import(
            /* webpackChunkName: "static/chunk/itemdetails.mobile" */ './selfcare/components/mobile/ItemDetails'
          );
          break;
        case 'order-confirmation':
          return import(
            /* webpackChunkName: "static/chunk/order-confirmation.mobile" */ './checkout/components/mobile/OrderConfirmation'
          );
        case 'SpinTheWheel':
          return import(
            /* webpackChunkName: "static/chunk/SpinTheWheel.mobile" */ './games/MobileGameLayout'
          );
          break;

        case 'auth':
          return import(
            /* webpackChunkName: "static/chunk/userauth.mobile" */ './refresh/pages/Authentication'
          );

        default:
          return '';
      }
    }
  },

  getDesktopChunk(name) {
    let chunk = getCommonChunk(name);
    if (chunk) {
      return chunk;
    } else {
      switch (name) {
        case 'cart':
          return import(
            /* webpackChunkName: "static/chunk/cart.desktop" */ './cart/components/desktop/cart'
          );
          break;
        case 'my-account':
          return import(
            /* webpackChunkName: "static/chunk/myaccount.desktop" */ './myaccount/components/desktop/accountLayout'
          );
          break;
        case 'wishlist':
          return import(
            /* webpackChunkName: "static/chunk/wishlist.desktop" */ './wishlist/components/desktop/Wishlist'
          );
        case 'shipping':
          return import(
            /* webpackChunkName: "static/chunk/myaccount.desktop" */ './shipping/components/desktop/Shipping'
          );
        case 'checkout':
          return import(
            /* webpackChunkName: "static/chunk/checkout.desktop" */ './checkout/components/desktop/Checkout'
          );
        case 'retry':
          return import(
            /* webpackChunkName: "static/chunk/checkout.desktop" */ './checkout/components/desktop/RetryPayment'
          );
        case 'selfcare':
          return import(
            /* webpackChunkName: "static/chunk/selfcare.desktop" */ './selfcare/components/desktop/Selfcare'
          );
          break;
        case 'itemdetails':
          return import(
            /* webpackChunkName: "static/chunk/itemdetails.desktop" */ './selfcare/components/desktop/ItemDetails'
          );
          break;
        case 'order-confirmation':
          return import(
            /* webpackChunkName: "static/chunk/order-confirmation.desktop" */ './checkout/components/desktop/OrderConfirmation'
          );
        case 'offers':
          return import(
            /* webpackChunkName: "static/chunk/offers.desktop" */ './offers/components/desktop'
          );
        case 'couponBonanza':
          return import(
            /* webpackChunkName: "static/chunk/couponBonanza.desktop" */ './components/desktop/eosspromo/PromoGuidelines'
          );
          break;

        case 'auth':
          return import(
            /* webpackChunkName: "static/chunk/userauth.desktop" */ './userauth/components/authLayout'
          );

        case 'SpinTheWheel':
          return import(
            /* webpackChunkName: "static/chunk/SpinTheWheel.desktop" */ './games/DesktopGameLayout'
          );
        default:
          return '';
      }
    }
  }
};